// The referred application name that a customer interacted
export var Referral;
(function (Referral) {
    Referral["AADMyApps"] = "AADMyApps";
    Referral["AboutMe"] = "AboutMe";
    Referral["Access"] = "Access";
    Referral["AdminPortal"] = "AdminPortal";
    Referral["AppGallery"] = "AppGallery";
    Referral["Audio"] = "Audio";
    Referral["BecomeTheAdmin"] = "BecomeTheAdmin";
    Referral["Bing"] = "Bing";
    Referral["Bookings"] = "Bookings";
    Referral["BusinessCentral"] = "BusinessCentral";
    Referral["Calendar"] = "Calendar";
    Referral["ClassNotebook"] = "ClassNotebook";
    Referral["Clipchamp"] = "Clipchamp";
    Referral["CloudPC"] = "CloudPC";
    Referral["ComplianceCenter"] = "ComplianceCenter";
    Referral["Create"] = "Create";
    Referral["CustomerVoice"] = "CustomerVoice";
    Referral["CRM"] = "CRM";
    Referral["Designer"] = "Designer";
    Referral["DocsCom"] = "DocsCom";
    Referral["Documents"] = "Documents";
    Referral["Dynamics365"] = "Dynamics365";
    Referral["Dynamics365CI"] = "Dynamics365CI";
    Referral["Dynamics365CSI"] = "Dynamics365CSI";
    Referral["Dynamics365FraudProtection"] = "Dynamics365FraudProtection";
    Referral["Dynamics365Invoicing"] = "Dynamics365Invoicing";
    Referral["Dynamics365ProductInsights"] = "Dynamics365ProductInsights";
    Referral["Dynamics365SalesInsights"] = "Dynamics365SalesInsights";
    Referral["DynamicsApp"] = "DynamicsApp";
    Referral["DynamicsNAV"] = "DynamicsNAV";
    Referral["ERP"] = "ERP";
    Referral["ExcelOnline"] = "ExcelOnline";
    Referral["ExchangeAdmin"] = "ExchangeAdmin";
    Referral["FamilySafety"] = "FamilySafety";
    Referral["Fluid"] = "Fluid";
    Referral["Forefront"] = "Forefront";
    Referral["ForefrontAdmin"] = "ForefrontAdmin";
    Referral["GraphApp"] = "GraphApp";
    Referral["HighLander"] = "HighLander";
    Referral["Invoicing"] = "Invoicing";
    Referral["ISVStudio"] = "ISVStudio";
    Referral["Kaizala"] = "Kaizala";
    Referral["LineOfBusinessApp"] = "LineOfBusinessApp";
    Referral["Lists"] = "Lists";
    Referral["Loop"] = "Loop";
    Referral["LoopComponent"] = "Loop component";
    Referral["LogicFlows"] = "LogicFlows";
    Referral["Mail"] = "Mail";
    Referral["Marketing"] = "Marketing";
    Referral["MeetingObject"] = "Meeting Object";
    Referral["MeetingNotes"] = "MeetingNotes";
    Referral["MetaOSApp"] = "MetaOSApp";
    Referral["MicrosoftStream"] = "MicrosoftStream";
    Referral["MOSStore"] = "MOSStore";
    Referral["MSN"] = "MSN";
    Referral["MyAnalytics"] = "MyAnalytics";
    Referral["MyApps"] = "MyApps";
    Referral["MyContent"] = "MyContent";
    Referral["Feed"] = "Feed";
    Referral["Netbreeze"] = "Netbreeze";
    Referral["NewsArticle"] = "NewsArticle";
    Referral["Newsfeed"] = "Newsfeed";
    Referral["NonProfitPortal"] = "NonProfitPortal";
    Referral["O365Settings"] = "O365Settings";
    Referral["ODBAdmin"] = "ODBAdmin";
    Referral["OfficeDotCom"] = "OfficeDotCom";
    Referral["OfficeForms"] = "OfficeForms";
    Referral["OfficeGraph"] = "OfficeGraph";
    Referral["OfficeStore"] = "OfficeStore";
    Referral["OneNoteOnline"] = "OneNoteOnline";
    Referral["OWASettings"] = "OWASettings";
    Referral["Park"] = "Park";
    Referral["Parature"] = "Parature";
    Referral["Partner"] = "Partner";
    Referral["Paw"] = "Paw";
    Referral["PDF"] = "PDF";
    Referral["People"] = "People";
    Referral["Photos"] = "Photos";
    Referral["PlayLists"] = "PlayLists";
    Referral["Platform"] = "Platform";
    Referral["PowerApps"] = "PowerApps";
    Referral["PowerAppsApp"] = "PowerAppsApp";
    Referral["PowerBI"] = "PowerBI";
    Referral["PowerPointOnline"] = "PowerPointOnline";
    Referral["Privacy"] = "Privacy";
    Referral["Project"] = "Project";
    Referral["Publisher"] = "Publisher";
    Referral["SecureScore"] = "SecureScore";
    Referral["Rewards"] = "Rewards";
    Referral["Security"] = "Security";
    Referral["SendASmile"] = "SendASmile";
    Referral["SharePoint"] = "SharePoint";
    Referral["SharePointAdmin"] = "SharePointAdmin";
    Referral["SharePointApp"] = "SharePointApp";
    Referral["SISSyncAdmin"] = "SISSyncAdmin";
    Referral["Skype"] = "Skype";
    Referral["SkypeAdmin"] = "SkypeAdmin";
    Referral["SkypeForBusiness"] = "SkypeForBusiness";
    Referral["SkypeMeetings"] = "SkypeMeetings";
    Referral["SkypeTeams"] = "SkypeTeams";
    Referral["StaffHub"] = "StaffHub";
    Referral["StaffNotebook"] = "StaffNotebook";
    Referral["Sway"] = "Sway";
    Referral["Tasks"] = "Tasks";
    Referral["Text"] = "Text";
    Referral["ThirdPartyApp"] = "ThirdPartyApp";
    Referral["ToDo"] = "ToDo";
    Referral["UnknownApp"] = "UnknownApp";
    Referral["Video"] = "Video";
    Referral["VisioOnline"] = "VisioOnline";
    Referral["VivaEngage"] = "VivaEngage";
    Referral["VivaGoals"] = "VivaGoals";
    Referral["VivaLearning"] = "VivaLearning";
    Referral["VivaPulse"] = "VivaPulse";
    Referral["VivaTopics"] = "VivaTopics";
    Referral["WAC"] = "WAC";
    Referral["Whiteboard"] = "Whiteboard";
    Referral["WindowsStore"] = "WindowsStore";
    Referral["WordOnline"] = "WordOnline";
    Referral["Yammer"] = "Yammer";
})(Referral || (Referral = {}));
//# sourceMappingURL=Referral.js.map